export const FETCH_ALL_USER = "FETCH_ALL_USER";
export const FETCH_USER_COUNT = "FETCH_USER_COUNT";